@if (!AccessAllowed && CompletedLoading) {
  <div>
    <h3 style="border: 2px solid;border-radius: 6px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);padding: 10px;">You don't have access to this function</h3>
  </div>
}

@if (AccessAllowed) {
  <div class="p-3 flex flex-column flex-auto">
    <h3 style="margin-top: 18px;" i18n>Sales for period: </h3>
    <div style="width: calc(100vw - 607px); float: left; margin-left: 272px; margin-bottom:20px;margin-top:-71px;">
      <div style="float:left; width: 200px;margin-right: 20px;">
        <span>From Date:</span>
        <p-datepicker [selectOtherMonths]="true" [(ngModel)]="FromDate" (onSelect)="fromDateChanged()" (onInput)="fromDateChanged()" firstDayOfWeek="1" dateFormat="dd/mm/yy" [showIcon]="true"></p-datepicker>
      </div>
      &nbsp;
      <div style="float:left; width: 200px;">
        <span>To Date:</span>
        <p-datepicker [selectOtherMonths]="true" [(ngModel)]="ToDate" [minDate]="FromDate" firstDayOfWeek="1" dateFormat="dd/mm/yy" [showIcon]="true"></p-datepicker>
      </div>
      &nbsp;
      <div style="float:left; width: 400px;margin-left:24px;">
        <span>Tags:</span><br>
        <p-multiselect [options]="tags" optionLabel="name" [(ngModel)]="chosentags" display="chip" style="float:left;">
          <ng-template let-value #selecteditems>
            @for (tag of chosentags; track tag) {
              <span>
                <p-chip class="mr-2" label="{{tag.name}}" [style]="{'background': tag.colour, 'color': 'white', 'border-radius': '5px' }">
                </p-chip>
              </span>
            }
            @if (!chosentags || chosentags.length === 0) {
              <div class="country-placeholder"> Select Tag(s) </div>
            }
          </ng-template>
        </p-multiselect>
        <div style="width:180px; float:left;margin-top:-16px;">
          <div style="float:left; width: 90px;">
            <button pButton pRipple type="button" class="p-button p-element p-button-success w-auto mt-3" style="background-color: #22C55E;border-color: #22C55E;margin-left: 12px;" (click)="doneDate()">
              Go
            </button>
          </div>
          <div style="float:left; width: 90px;margin-top:16px;">
            @if (ListData) {
              <button
                type="button"
                pButton
                pRipple
                (click)="salesTable.exportCSV()"
                class="mr-2"
                pTooltip="Export to CSV"
                tooltipPosition="bottom" [iconOnly]="true"><span class="p-button-icon pi pi-file-excel" aria-hidden="true"></span></button>
              }
            </div>
          </div>
        </div>
        <!-- <div style="float:left; width: 90px;">
        <button pButton pRipple type="button" class="p-button p-element p-button-success w-auto mt-3" style="background-color: #22C55E;border-color: #22C55E;margin-top: 24px !important;margin-left: 12px;" (click)="doneDate()">
          Go
        </button>
      </div>  -->
      <!-- <div style="float:left; width: 90px;margin-top:24px;">
      <button *ngIf="ListData"
        type="button"
        pButton
        pRipple
        (click)="salesTable.exportCSV()"
        class="mr-2"
        pTooltip="Export to CSV"
        tooltipPosition="bottom" [iconOnly]="true"><span class="p-button-icon pi pi-file-excel" aria-hidden="true"></span></button>
      </div> -->
    </div>
    <div class="surface-card p-4 shadow-2 border-round">
      <p-table  #salesTable
        [columns]="cols"
        [value]="ListData"
        responsiveLayout="scroll"
        style="display:none;">
        <ng-template #header>
          <tr>
            <th width="10%">Crerated
            </th>
            <th width="10%">Start Date
            </th>
            <th width="8%">Time
            </th>
            <th width="15%">Package
            </th>
            <th>Sales ID
            </th>
            <th>Sales Type
            </th>
            <th>Name
            </th>
            <th>
              Discount
            </th>
            <th>
              Discount Value
            </th>
            <th>Guests
            </th>
            <th>Total
            </th>
            <th>Booking Fee
            </th>
            <th>Extras
            </th>
            <th>Admissions
            </th>
            <th>Paid
            </th>
            <th>O/S
            </th>
          </tr>
        </ng-template>
        <ng-template #body let-rowData>
          <tr>
            <td>{{rowData.created_date  | date:'dd/MM/yy'}}</td>
            <td>{{rowData.start_date  | date:'dd/MM/yy'}}</td>
            <td>{{rowData.start_date  | date:'HH:mm' : 'UTC'}}</td>
            <td>{{rowData.salename }}</td>
            <td>{{rowData.saleid }}</td>
            <td>{{rowData.saletype  }}</td>
            <td>{{rowData.customername }}</td>
            <td>{{rowData.discounttext }}</td>
            <td>{{rowData.discountvalue  | currency: (rowData.currency || CurrencySymbol)}}</td>
            <td>{{rowData.guests}}</td>
            <td>{{rowData.totalamount  | currency: (rowData.currency || CurrencySymbol)}}</td>
            <td>{{rowData.totalbookingfees | currency: (rowData.currency || CurrencySymbol)}}</td>
            <td>{{rowData.totalextras | currency: (rowData.currency || CurrencySymbol)}}</td>
            <td>{{rowData.totaladmissions | currency: (rowData.currency || CurrencySymbol)}}</td>
            <td>{{rowData.totalpaid   | currency: (rowData.currency || CurrencySymbol)}}</td>
            @if (rowData.totaloutstanding  <=0) {
              <td>{{rowData.totaloutstanding  | currency: (rowData.currency || CurrencySymbol)}}</td>
            }
            @if (rowData.totaloutstanding  >0) {
              <td><span style="color: Red; font-weight: bold;">{{rowData.totaloutstanding  | currency: (rowData.currency || CurrencySymbol)}}</span></td>
            }
          </tr>
        </ng-template>
      </p-table>
      <p-table
        [columns]="cols"
        [value]="ListDataFormatted"
        responsiveLayout="scroll">
        <ng-template #body let-rowData>
          <tr>
            <td style="font-weight: bold;">
              <button style="width: 25px;height: 25px;border-radius: 4px;border: 2px solid #999999;background-color: transparent;" type="button" (click)="collapseDiv('DIV-' + rowData.DID, rowData.DID)">
                <span style="margin-left: 1px;font-size: 10px;float: left;" [class]="divClass[rowData.DID]"></span>
              </button>&nbsp;&nbsp;{{rowData.method}}@if (divTotal[rowData.DID]) {
              <span>&nbsp;&nbsp;-&nbsp;&nbsp;Total: {{rowData.total | currency: CurrencySymbol}}</span>
            }
          </td>
        </tr>
        <tr>
          <td id="DIV-{{rowData.DID}}">
            <p-table
              [columns]="cols"
              [value]="rowData.data"
              responsiveLayout="scroll">
              <ng-template #header let-columns>
                <tr>
                  <th style="text-align: left; width: 10%">
                    Date
                  </th>
                  <th style="text-align: left; width: 10%">
                    Start Time
                  </th>
                  <th style="text-align: left; width: 10%">
                    Sales Name
                  </th>
                  <th style="text-align: left; width: 25%">
                    Sales ID
                  </th>
                  <th style="text-align: left; width: 25%">
                    Sales Type
                  </th>
                  <th style="text-align: left; width: 15%">
                    Name
                  </th>
                  <th style="text-align: left; width: 10%">
                    Discount
                  </th>
                  <th style="text-align: left; width: 5%">
                    Discount Value
                  </th>
                  <th style="text-align: right; width: 10%">
                    Guests
                  </th>
                  <th style="text-align: right; width: 10%">
                    Total
                  </th>
                  <th style="text-align: right; width: 10%">
                    Booking Fee
                  </th>
                  <th style="text-align: right; width: 10%">
                    Extras
                  </th>
                  <th style="text-align: right; width: 10%">
                    Admissions
                  </th>
                  <th style="text-align: right; width: 10%">
                    Paid
                  </th>
                  <th style="text-align: right; width: 10%">
                    Outstanding
                  </th>
                </tr>
              </ng-template>
              <ng-template #body let-rowData>
                <tr>
                  <td>{{rowData.datetime | date:'dd/MM/yy'}}</td>
                  <td>{{rowData.datetime | date:'HH:mm' : 'UTC'}}</td>
                  <td>{{rowData.salename}}</td>
                  <td>{{rowData.saleid}}</td>
                  <td>{{rowData.saletype}}</td>
                  <td>{{rowData.customername }}</td>
                  <td>{{rowData.discounttext }}</td>
                  <td style="text-align:right;">{{rowData.discountvalue  | currency: (rowData.currency || CurrencySymbol)}}</td>
                  <td style="text-align:right;">{{rowData.guests}}</td>
                  <td style="text-align:right;">{{rowData.totalamount  | currency: (rowData.currency || CurrencySymbol)}}</td>
                  <td style="text-align:right;">{{rowData.totalbookingfees | currency: (rowData.currency || CurrencySymbol)}}</td>
                  <td style="text-align:right;">{{rowData.totalextras | currency: (rowData.currency || CurrencySymbol)}}</td>
                  <td style="text-align:right;">{{rowData.totaladmissions | currency: (rowData.currency || CurrencySymbol)}}</td>
                  <td style="text-align:right;">{{rowData.totalpaid | currency: (rowData.currency || CurrencySymbol)}}</td>
                  @if (rowData.totaloutstanding  <=0) {
                    <td style="text-align:right;">{{rowData.totaloutstanding | currency: (rowData.currency || CurrencySymbol)}}</td>
                  }
                  @if (rowData.totaloutstanding  >0) {
                    <td style="text-align:right;"><span style="color: Red; font-weight: bold;">{{rowData.totaloutstanding | currency: (rowData.currency || CurrencySymbol)}}</span></td>
                  }
                </tr>
              </ng-template>
              <ng-template  #footer>
                <tr>
                  <td>Total</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td style="text-align:right;">{{rowData.totaltotdiscount | currency: CurrencySymbol}}</td>
                  <td style="text-align:right;">{{rowData.guesttotal}}</td>
                  <td style="text-align:right;">{{rowData.total | currency: CurrencySymbol}}</td>
                  <td style="text-align:right;">{{rowData.bookingfeetotal | currency: CurrencySymbol}}</td>
                  <td style="text-align:right;">{{rowData.extrastotal | currency: CurrencySymbol}}</td>
                  <td style="text-align:right;">{{rowData.admissionstotal | currency: CurrencySymbol}}</td>
                  <td style="text-align:right;">{{rowData.paid | currency: CurrencySymbol}}</td>
                  <td style="text-align:right;">{{rowData.ostotal | currency: CurrencySymbol}}</td>
                </tr>
              </ng-template>
            </p-table>
          </td>
        </tr>
      </ng-template>
      <ng-template  #footer>
        @if (ListDataFormatted.length == 0) {
          <tr>
            <td style="text-align: center;" colspan="8">
              There is no data for the selected date range.
            </td>
          </tr>
        }
        @if (TotalAmount > 0) {
          <tr>
            <td>Total: {{TotalAmount | currency: CurrencySymbol}} &nbsp;-&nbsp;Total Booking Fees: {{TotalBookingFees | currency: CurrencySymbol}} &nbsp;-&nbsp;Total Extras: {{TotalExtras | currency: CurrencySymbol}} &nbsp;-&nbsp;Total Admissions: {{TotalAdmissions | currency: CurrencySymbol}} &nbsp;-&nbsp;Total Discounts: {{TotalDiscounts | currency: CurrencySymbol}} &nbsp;-&nbsp;Total O/S: {{TotalOS | currency: CurrencySymbol}}&nbsp;-&nbsp;Total Guests: {{TotalGuests}}</td>
          </tr>
        }
      </ng-template>
    </p-table>
  </div>
</div>
}
